import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedContractView } from "./SignedContractView";
import { SignedContractViewStore } from "../../store/SignedContractViewStore";
import { useStore } from "../../../../hooks";

export const SignedContractViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/signedContract/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SignedContractViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SignedContractView signedContractViewStore={store} />
      </PageLayout>
    </div>
  );
});
